<style lang="scss" rel="stylesheet/scss" scoped>
.app_panel{
    background: #fff;
    border-radius: 2px;
    padding: 24px;
    .panel_head{
        margin-bottom: 24px;
        font-size: 18px;
        color: #333333;
        font-weight: 600;
        line-height: 18px;
        .href{
            float: right;
            >a{
                font-size: 12px;
                color: #666666;
                font-weight:400;
                &:hover{
                    color: #1261ff;
                     &::after{
                          border-top: 2px solid #1261ff;
                          border-right: 2px solid #1261ff;
                     }
                }
                &::after{
                    content: '';
                    display: inline-block;
                    $width:8px;
                    width: $width;
                    height: $width;
                    margin-left: 2px;
                    margin-bottom: 1px;
                    border-top: 2px solid #666666;
                    border-right: 2px solid #666666;
                    transform: rotate(45deg);
                }
            }
        }
    }
}
</style>

<template lang="html">
    <section class="app_panel" v-loading="loading">
        <header class="panel_head">
            {{title}}
            <span v-if="href" class="href">
                <a v-if="!href.current" :href="href.url" target="_blank">{{href.text ? href.text : '查看详情'}} ></a>
                <router-link  v-else :to="href.url">{{href.text ? href.text : '查看详情'}}</router-link>
            </span>
            <slot  name="href">

            </slot>
        </header>
        <section class="panel_content">
            <slot name="content">
                <p v-html="initData" slot="content" v-if="initData"></p>
                <p v-else>放入盒子内容</p>
            </slot>
        </section>
        <footer class="panel_foot clearfix">
            <slot name="foot">
            </slot>
        </footer>
    </section>
</template>

<script>

export default {
    props: ['loading', 'initData', 'title', 'href'],
    computed: {

    }
}
</script>
